import { INPUT_TYPE } from 'src/@types/enum'
import { I18NS } from './i18ns'

/** 创建账号登陆 */
export function createAccountStructure() {
  return [
    {
      type:     INPUT_TYPE.ACCOUNT,
      key:      'user',
      title:    I18NS.ENTER_ID_WORD,
      errorTip: I18NS.NEED_ACCOUNT_WORD,
      name:     'user'
      
    },
    {
      type:     INPUT_TYPE.PASSWORD,
      key:      'password',
      title:    I18NS.ENTER_PASSWORD_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'password'
      
    },
    {
      type:     INPUT_TYPE.IMG_VERIFY,
      key:      'imageCode',
      title:    I18NS.ENTER_VERIFY_CODE_WORD,
      errorTip: I18NS.NEED_CHECK_CODE_WORD,
      name:     'imageCode'
      
    }
  ]
}

/** 创建邮件登陆 */
export function createEmailStructure() {

  return [
    {
      type:     INPUT_TYPE.EMAIL,
      key:      'email',
      title:    I18NS.ENTER_EMAIL_WORD,
      errorTip: I18NS.NEED_EMAIL_WORD,
      name:     'email'
      
    },
    {
      type:     INPUT_TYPE.GET_EMAIL_CODE,
      key:      'verifyCode',
      title:    I18NS.ENTER_EMAIL_CHECK_CODE_WORD,
      errorTip: I18NS.NEED_EMAIL_CHECK_CODE_WORD,
      name:     'verifyCode'
      
    },
    {
      type:     INPUT_TYPE.IMG_VERIFY,
      key:      'imageCode',
      title:    I18NS.ENTER_VERIFY_CODE_WORD,
      errorTip: I18NS.NEED_CHECK_CODE_WORD,
      name:     'imageCode'
      
    }
  ]
}

/** 创建手机登陆 */
export function createPhoneStructure() {

  return [
    {
      type:     INPUT_TYPE.PHONE,
      key:      'user',
      title:    I18NS.ENTER_PHONE_NUM_WORD,
      errorTip: I18NS.NEED_PHONE_WORD,
      name:     'user'
      
    },
    {
      type:     INPUT_TYPE.GET_SMS_CODE,
      key:      'verifyCode',
      title:    I18NS.ENTER_CHECK_CODE_WORD,
      errorTip: I18NS.NEED_SMS_CHECK_CODE_WORD,
      name:     'verifyCode'
      
    },
    {
      type:     INPUT_TYPE.IMG_VERIFY,
      key:      'imageCode',
      title:    I18NS.ENTER_VERIFY_CODE_WORD,
      errorTip: I18NS.NEED_CHECK_CODE_WORD,
      name:     'imageCode'
      
    }
  ]
}

/** 忘记密码表单1 */
export function createForgetPw1Structure() {
  return [
    {
      type:     INPUT_TYPE.ACCOUNT,
      key:      'user',
      title:    I18NS.ENTER_ID_WORD,
      errorTip: I18NS.NEED_ACCOUNT_WORD,
      name:     'user'
      
    },
    {
      type:     INPUT_TYPE.PHONE_OR_EMAIL,
      key:      'phoneOrEmail',
      title:    I18NS.ENTER_EMAIL_OR_PHONE_WORD,
      errorTip: I18NS.ENTER_VALID_EMAIL_OR_PHONE_WORD,
      name:     'phoneOrEmail'
      
    },
    {
      type:     INPUT_TYPE.PHONE_OR_EMAIL_CODE,
      key:      'verifyCode',
      title:    I18NS.ENTER_EMAIL_OR_PHONE_CHECK_CODE_WORD,
      errorTip: I18NS.NEED_CHECK_CODE_WORD,
      name:     'verifyCode'
      
    }
  ]
}

/** 忘记密码表单1 */
export function createForgetPw2Structure() {
  return [
    {
      type:     INPUT_TYPE.PASSWORD,
      key:      'password',
      title:    I18NS.ENTER_PASSWORD_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'password'
      
    },
    {
      type:     INPUT_TYPE.AGAIN_PASSWORD,
      key:      'password2',
      title:    I18NS.ENTER_PASSWORD_AGAIN_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'password2'
      
    }
  ]
}

/** 定期更密 */
export function createDenserPeriodStructure() {
  return [
    {
      type:     INPUT_TYPE.PASSWORD,
      key:      'oldPassword',
      title:    I18NS.ENTEROLDPASSWORD_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'oldPassword'
      
    }, ,
    {
      type:     INPUT_TYPE.PASSWORD,
      key:      'password',
      title:    I18NS.ENTER_PASSWORD_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'password'
      
    },
    {
      type:     INPUT_TYPE.AGAIN_PASSWORD,
      key:      'password2',
      title:    I18NS.ENTER_PASSWORD_AGAIN_WORD,
      errorTip: I18NS.NEED_EDIT_PASSWORD_WORD,
      name:     'password2'
      
    }
  ]
}